import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { Stack } from '@mui/joy';
import { useDashStore, useWellnessLogs } from 'src/hooks';
import { DataTable, IconButton, Card, Select } from 'src/components';
import {
  getAllUserColumns,
  getSingleUserColumns,
  downloadLogCSV,
  Loading,
  Container,
} from './helpers';
import Profile from '../../Profile/Profile';

const SelectableTableTitle = (props) => {
  const { tableView, setTableView } = props;
  return (
    <Stack
      direction="row"
      sx={{ gap: 2, margin: '-10px 0px 0px -10px', padding: '10px 0px 0px 10px' }}>
      <Select
        id="table-view-select"
        options={['All', 'Most Recent']}
        value={tableView}
        setValue={setTableView}
        sx={{ minWidth: '150px', maxHeight: '40px' }}
      />
      Logs{tableView === 'Most Recent' ? ' (for each user)' : ''}
    </Stack>
  );
};

const defaultSortModel = {
  field: 'dateAndTimeToLog',
  sort: 'desc',
};

export const WellnessLogsTable = () => {
  const { logs: allLogs, mostRecentLogs, loadingLogs } = useWellnessLogs();
  const { selectedUser, selectedAppUserData, appUsers, loadingNewAppUsers, group, viewingProfile } =
    useDashStore();
  const allUsers = selectedUser.id === 'All Users';

  const [tableView, setTableView] = useState('All');
  const [columns, setColumns] = useState(getAllUserColumns(group));

  useEffect(() => {
    setColumns(allUsers ? getAllUserColumns(group) : getSingleUserColumns(group));
  }, [allUsers, group]);

  const tableData = allUsers
    ? tableView === 'All'
      ? allLogs
      : mostRecentLogs
    : allLogs.filter((log) => {
        return log.username === selectedUser.username;
      });

  return (
    <Card
      sx={{ marginTop: '20px', height: 'calc(100vh - 285px)', overflow: 'auto' }}
      title={
        allUsers ? (
          <SelectableTableTitle tableView={tableView} setTableView={setTableView} />
        ) : (
          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <Typography variant="h2" sx={{ marginRight: '10px' }}>
              {selectedUser.username} {viewingProfile ? 'Profile' : 'Logs'}
            </Typography>
          </Stack>
        )
      }
      headerContent={
        <IconButton
          icon="download"
          onClick={() => {
            downloadLogCSV(
              tableData,
              `wellnessLogs${allUsers ? '' : `_${selectedUser.username}`}${
                tableView === 'Most Recent' && allUsers ? '_Recent' : ''
              }.csv`
            );
          }}
          tooltip={`Download Wellness Logs`}
        />
      }>
      {loadingLogs || loadingNewAppUsers ? (
        <Loading />
      ) : !appUsers.length ? (
        <Container>
          <Typography variant="instructions" style={{ fontSize: '24px' }}>
            No Users
          </Typography>
        </Container>
      ) : allLogs.length ? (
        <Stack sx={{ marginTop: '20px', overflowY: 'auto' }}>
          {viewingProfile ? (
            <Profile />
          ) : (
            <DataTable
              rowIDs={allUsers ? ['username', 'createdAt'] : ['createdAt']}
              columns={columns}
              data={tableData}
              initialSort={defaultSortModel}
              hasPagination
            />
          )}
        </Stack>
      ) : (
        <Container>
          <Typography variant="instructions" style={{ fontSize: '24px' }}>
            No Data
          </Typography>
        </Container>
      )}
    </Card>
  );
};
